module.exports = __webpack_public_path__ + "img/schnittkante_feuerrot_ral3000.b649958c.jpg";